export default {
  // mall: {
  //   StartTime: 'Start Time',
  //   EndTime: 'End Time',
  //   ToProcessDate: 'Go Date',
  //   backTracking: 'Return Date',
  //   sharing: 'Share',
  //   AirplaneModelTxt: 'Model',
  //   ticketfeeFloat: 'In addition to built-in fuel',
  //   peopleTypeExplain: "Passenger Booking",
  //   bookingTicketExplain: 'If you want to book a child/baby ticket, please contact our customer service.',
  //   onlySeeDirect: 'Look at direct flight',
  //   hiddenSharedFlight: 'Hide shared flights',
  //   ActualCarrier: 'Actual-carrier',
  //   stayTxt: 'Stay',
  //   turnTxt: 'Turn',
  //   priceRemarks: 'The following fees are the average price of 1 adult 1 child 1 baby',
  //   AgreementPrice: 'AgreementPrice',
  //   tax: 'Tax',
  //   trainHolderKeyWords: 'Domestic train ticket',
  //   bookingRemarks: 'Only a maximum of 5 passengers can be booked at a time',
  //   beginTxt: '始',
  //   passTxt: '过',
  //   endTxt: '终',
  //   StandingOrder: 'Numeber',
  //   stationName: 'Station',
  //   arrivalTimeTxt: 'To time',
  //   departTimeTxt: 'Send time',
  //   departDate: 'Departure date',
  //   arrivalDate: 'Arrival date',
  //   hotelHolderKeyWords: 'Key words',
  //   HotelRemarks: 'Please do not exceed 5 rooms, please do not stay more than 20 nights. For special reservations, please contact our customer service. ',
  //   TrainRemarks:'Hint: Tickets are available from 7:30 am to 22:30 pm. Tickets, changes and refunds must be no later than 30 minutes before the start of the journey. Please pay within 10 minutes for the day of the trip and 25 minutes for the 24 hours.',
  //   mapTxt: 'Map/navigation',
  //   detailsOrFacilities: 'Details/Facility',
  //   noSooner: 'No early',
  //   breakfast: 'Breakfast',
  //   breakfastTxt: 'Breakfast',
  //   noCancellation: 'Cannot cancel',
  //   timeToCancel: 'Limit time',
  //   RoomsTxt: 'Number of rooms',
  //   hotelUnit: 'night',
  //   checkInTxt: 'Check-in',
  //   checkOutTxt: 'Check-out',
  //   checkInDate: 'Check-in-date',
  //   checkOutDate: 'Check-out-date',
  //   Frequenter: 'President',
  //   Temporary: 'Temporary',
  //   TemporaryInformation: 'People information',
  //   addFrequenter: 'Add employee',
  //   addTemporary: 'Add guest',
  //   TravelStandard: 'Policy',
  //   hightToLow: 'High to low',
  //   lowToHight: 'Low to high',
  //   morningToNight: 'Time',
  //   nightToMorning: 'Late to early',
  //   starLevelTxt: 'Star',
  //   filtrateTxt: 'Filter',
  //   timeTxt: 'Time',
  //   fromTo: 'From',
  //   portion: 'Parts',
  //   contactNumber: 'Mobile',
  //   conformToRules: 'NoViolate',
  //   breakToRules: 'Violate',
  //   unlimited: 'Unlimited',
  //   beforeDay: 'Before-day',
  //   afterDay: 'After-day',
  //   adequateTxt: 'Full',
  //   Remaining: 'Only ',
  //   taxesTxt: 'Taxe',
  //   BackTorule: 'RegRules',
  //   booking: 'Book',
  //   onlinePay: 'Online',
  //   departTxt: 'Departure',
  //   arrivalTxt: 'Arrival',
  //   sheet: 'Sheet',
  //   NoTicket: 'Sold out',
  //   orderFilltitle: 'Review and Book for Business',
  //   tripInfosTitle: 'Number of passenger',
  //   BookingInformation: 'Booking instructions',
  //   tripInfosRemarks: 'For your smooth travel, please be sure to fill in the same documents as the travel documents.',
  //   addTraveller: 'Add passenger',
  //   UserName: 'Name',
  //   contactInfosTitle: 'Contact information',
  //   contacts: 'Contacts',
  //   Phone: 'Mobile',
  //   Email: 'Email',
  //   InstructTitle: 'Deduction Instructions',
  //   InstructContent: 'The pre-authorization or deduction will be made according to your payment method. If the order is not confirmed, the pre-authorization will be released or a full refund will be made to your payment account. This order cannot be cancelled after confirmation. If you do not check in, your first day room rate will be charged. If you leave early, the first day of departure will be deducted. ',
  //   SpecialTipsTitle: 'Special Tips',
  //   SpecialTipsContent: 'The check-in time for this hotel is 14:00 and the standard check-out time is 12:00. If you check in early or postpone your departure, you will be charged a fee as appropriate. ',
  //   travelInformationTitle: 'Travel information',
  //   CostCenter: 'Cost center',
  //   TravelPurpose: 'TravelPur',
  //   ProjectCode: 'ProjtCode',
  //   contraryReason: 'Breaking the cause',
  //   ViolateTravelRules: 'Violation of travel rules',
  //   SpecialRequirement: 'Special needs',
  //   SpecialRequirementTips: 'Need-remark',
  //   specialRequirementContent: 'Your special requirements, we will try to coordinate. If you are unable to meet, we will not notify you otherwise, please forgive me. ',
  //   otherRequirement: 'Other needs',
  //   consentAgreement: 'Submit agree',
  //   importantTerms: 'Booking instructions and important terms',
  //   BookingHint: 'The default electronic contract, paper contract, please call customer service. ',
  //   CostDetails: 'Cost breakdown',
  //   payTotalPrice: 'Total',
  //   totalPrice: 'Total',
  //   roomUnit: 'Room',
  //   peopleUnit: 'people',
  //   details: 'Details',
  //   CustomerService: 'Contact Us',
  //   SubmissionOrPayment: 'Pay',
  //   frequentlnformationTitle: 'Passenger',
  //   TravellerTitle: 'Visitor Name',
  //   EnglishName: 'Name',
  //   LastName: 'Surname',
  //   firstName: 'Givenname',
  //   NameOrIdCardTips: 'To ensure a smooth trip, please ensure that the travel name is the same as the ID. ',
  //   CertificateInformatTitle: 'Certificate Information',
  //   ExpireDate: 'Valid-date',
  //   otherInfosTitle: 'Other information',
  //   Sex: 'Gender',
  //   Birthday: 'Birth date',
  //   Nationality: 'Nationality',
  //   optionalCard: 'Current Travel Card (optional)',
  //   reminderInfos: 'In order for you to travel smoothly, please ensure that the travel end date is at least 6 months earlier than the validity period of the document, and confirm that the true and valid ID number is filled in. After the order is submitted, it cannot be modified',
  //   addOrEditTraveller: 'Add/edit passengers',
  //   AllOrder: 'All orders',
  //   orderStatus: 'OrderStatus',
  //   departTime: 'Departure time',
  //   orderDetail: 'Order details',
  //   CancelOrder: 'Cancel Order',
  //   ApprovalRefused: 'Approval rejection',
  //   ApproveSucc: 'Approval Pass',
  //   PayNow: 'Pay now',
  //   Refund: 'Refund',
  //   SubmitOrder: "Submit order",
  //   Change: 'Change',
  //   PriceDetail: 'Price Details',
  //   CheckOrderProgress: 'View order progress',
  //   flightInformation: 'Flight information',
  //   orderNumber: 'Order ID',
  //   BookingTime: 'BookingTime',
  //   First: 'First',
  //   Journey: 'Cheng',
  //   few: 'Between',
  //   BackToChangeTips: 'The final amount is subject to the review of the airline company. If you have any questions, please call customer service.',
  //   pleaseChoose: 'Please select',
  //   ThePassengers: 'The traveler',
  //   Transfer: 'Transfer',
  //   Flight: 'Flight',
  //   RefundRoomsDate: 'Check-out time',
  //   TheReason: 'The reason',
  //   TheTrain: 'The number of trips',
  //   hour: 'h',
  //   minute: 'm',
  //   ThePassengerInformation: 'Traveler Information',
  //   NewTrainInformation: 'New Train Information',
  //   OriginalTrainInformation: 'Original train information',
  //   NewFlightInformation: 'New Train Information',
  //   OriginalFlightInformation: 'Original train information',
  //   NextStep: 'Next',
  //   ChangeDate: 'Change date',
  //   SelectChangeFlight: 'Choose the number of flights to change',
  //   SelectRefundFlight: 'Choose the number of flights to refund',
  //   SelectChangeTrain: 'Choose the number of trains to change',
  //   SelectRefundFlight: 'Choose the number of trains to refund',
  //   SelectRefundHotel: 'Please choose a hotel to refund the ticket',
  //   SelectChangeDate: 'Choose the date of the change',
  //   Department: 'Department',
  //   ApprovalStatus: 'Approval Status',
  //   ConfidentialInformation: 'Voucher',
  //   TradeInformation: 'Transaction Information',
  //   Insurance: 'Insurance',
  //   Home: 'Home',
  //   Stroke: 'Travel',
  //   Me: 'Me',
  //   Within:'Within',
  //   Level:'Level',
  //   TravelApproval: 'Travel Policy',
  //   TravelRulesName: 'Travel Rule Name',
  //   MinimumPriceBase: 'Minimum price benchmark',
  //   RealFlightControl: 'Real Flight Control',
  //   AdvanceBookingTime: 'Advance reservation time',
  //   ClassLimit: 'class level limit',
  //   SeatClassLimit: 'Seat level limit',
  //   AgreementAirlinePriority: 'Agreement ticket priority',
  //   AgreementHotelPriority: 'Agreement hotel priority',
  //   MaximumAmountConsumption: 'Capacity limit',
  //   ApprovalName: 'Approval Name',
  //   Other: 'Other',
  //   FirstClassCity: 'First class city',
  //   SecondaryCity: 'Secondary city',
  //   ThreeLevelCity: 'Three-level city',
  //   SeatSelectionService: 'Selection Service',
  //   Bezel: 'window',
  //   Aisle: 'Aisle',
  //   NewContacts: 'Add Contact',
  //   AdditionalInvoiceInformation: 'Add/Edit invoice',
  //   InvoiceInformation: 'Invoice Information',
  //   InvoiceTitle: 'Invoice Header',
  //   TariffItem: 'Tax Number',
  //   SetDefaultContacts: 'Set default contact',
  //   ConsigneeAddress: 'Address',
  //   NewCommonAddresses: 'Add Address',
  //   default: 'Def',
  //   City: 'City',
  //   Address: 'Address',
  //   Postcode: 'ZipCode',
  //   AddCommonAddresses: 'Add/Edit Addresses',
  //   DepartureTime: 'Take time',
  //   Airport: 'Airport',
  //   ShippingSpace: 'Cabin',
  //   AirlineCompany: 'Airline',
  //   '150OrLess': '￥150 or less',
  //   '150And300': '￥150-300',
  //   '300And450': '￥300-450',
  //   '450And600': '￥450-600',
  //   '600OrMore': '￥600 or more',
  //   TwoStarsOrLess: 'Two stars and below',
  //   ThreeStar: 'Three stars/comfortable',
  //   FourStar: 'Four-star/high-end',
  //   FivesStar: 'Five stars/luxury',
  //   Apartment: 'Apartment',
  //   Inn: 'Inn',
  //   FamilyInn: 'Family Inn',
  //   YouthHostel: 'Youth hostel',
  //   CoupleHotel: 'Couple hotel',
  //   GardenCourtyard: 'Garden courtyard',
  //   SeaView: 'Sea view',
  //   Farmhouse: 'Farm house',
  //   HotSpringHotel: 'Hot spring hotel',
  //   GolfHotel: 'Golf Hotel',
  //   Siheyuan: 'Siheyuan',
  //   Villa: 'Villa',
  //   PartyCooking: 'Party cooking',
  //   BusinessTtravelHome: 'Business travel home',
  //   LeisureMood: 'Leisure mood',
  //   SeeDoctor: "See a doctor",
  //   VacationLeisure: "Vacation leisure",
  //   TrainAndLearn: "Training and learning",
  //   GetTogether: "Get together",
  //   HoneymoonTrip: "Honeymoon trip",
  //   boutiqueHotel: "Boutique Hotel (Designer Hotel)",
  //   FreeWifi: "Free wifi",
  //   FreeParking: "Free parking",
  //   IndoorPool: "Indoor swimming pool",
  //   OutdoorPool: "Outdoor pool",
  //   Gym: "Gym",
  //   district:'District',
  //   business:'Business',
  //   BusinessCenter: "Business center",
  //   MeetingRoom: "Meeting room",
  //   HotelRestaurant: "Hotel restaurant",
  //   MorningCall: "Morning Call",
  //   LuggageStorage: "Luggage storage",
  //   TwinBed: "Twin bed",
  //   BigBed: "Big bed",
  //   FreePickUpService: "Free pick-up service",
  //   Price: 'Price',
  //   StarLevel: 'Star',
  //   Specialtie: 'Specialtie',
  //   Service: 'Facility service',
  //   DetailsOrFacilities: 'Details/Facilities',
  //   HotelDetail: 'Hotel Detail',
  //   ModelSelection: 'Model selection',
  //   HighSpeedRail: 'High-speed rail(G/C)',
  //   MotorCar: 'Motor car(D)',
  //   Ordinary: 'Ordinary(Z/T/K)',
  //   Other: 'Other(L/Y,etc)',
  //   DepartureOrArrival: 'Departure/Arrival',
  //   Service: 'Service',
  //   Date: 'Date',
  //   Status: 'Status',
  //   OldSystem: 'Please check the computer version',
  //   Welcome: 'Welcome',
  //   PleaseLogIn: 'Please Log in',
  //   FlightTips: 'Cheap ticket, comfortable travel',
  //   HotelTips: 'Exclusive stay, exclusive for business travel',
  //   TrainTips: 'One-click lightning ticket',
  //   TourTips: 'Featured Special Travel',
  //   Invoice: 'Invoice',
  //   Identifier: 'Identifier',
  //   TicketInquiry: 'Ticket Inquiry',
  //   TrainInquiry: 'Train Inquiry',
  //   HotelInquiry: 'Hotel Inquiry',
  //   ConsumerHotline: "Service tel",
  //   WeChatService: "WeChat Service",
  //   TravelPolicy: 'Travel Policy',
  //   RemarkInfosTitle: 'Remark',
  //   EditData: 'Edit Data',
  //   RecommendFlight: 'Recom',
  //   OriginalFlight: 'Original Flight',
  //   More: 'More',
  //   Hidden: 'Hidden',
  //   JetFuel: 'Jet Fuel',
  //   Booking: 'Booking',
  //   CurrentPosition: 'Current Position',
  //   Room: 'Room',
  //   SquareMeters: 'Square Meters',
  //   CanLive: 'Can Live',
  //   Floor: 'Floor',
  //   Layer: 'Layer',
  //   ServiceFee: 'Service Fee',
  //   InsurancePremium: 'Insurance Premium',
  //   Yuan: 'Yuan',
  //   ContactHotel: 'Contact Hotel',
  //   After: 'After',
  //   Before: 'Before',
  //   For: 'For',
  //   DueTo: 'Due To',
  //   ViolationPolicy: 'Violation Policy',
  //   CompliancePolicy: 'Compliance Policy',
  //   BusinessInformation: 'Business Information',
  //   RefuseReason: 'Refuse Reason',
  //   Against: 'Against',
  //   Policy: 'Policy',
  //   DetailedReason: 'Detailed Reason',
  //   Wait: 'Wait',
  //   Approval: 'Approval',
  //   Breach: 'Breach',
  //   AirlineAuditStandards: 'Actual subject to airline audit',
  //   ConfirmOrder: 'Confirm Order',
  //   FlightInformation: 'Flight Infor',
  //   Voyage: 'Voyage',
  //   DeparturePlace: 'Depart Place',
  //   ArrivePlace: 'Arrive Place',
  //   AddVoyage: 'Add Voyage',
  //   PassengersNumbers:'Pgers Num',
  //   ShipType:'Ship Type',
  //   PassengersType:'Pgers Type',
  //   ShipCompany:'Ship Com',
  //   Remarks:'Remarks',
  //   PackUp:'Hidden',
  //   Show:'Show',
  //   DocumentType:'Card Type',
  //   CardNo:'Card No',
  //   InvoiceRole:'Role',
  //   InvoiceType:'Type',
  //   BankName:'Name' ,
  //   BankAccount:'Account',
  //   RegisteredAddress:'Address',
  //   RegisteredPhone:'Phone',
  //   ChangeReason:'Change Reason',
  //   VoucherNumber:'VoucherNo',
  //   CancelReason:'Cancel Reason',
  //   ChildInfantBooking:'ChildInfantBook',
  //   BookingInformation:'Booking Information'



  // },
  // placeholders: {
  //   contacts: 'Contact name',
  //   Phone: 'Mobile number',
  //   Email: '(Optional) Contact Email',
  //   CostCenter: 'cost center',
  //   TravelPurpose: 'purpose of travel',
  //   ProjectCode: 'project code',
  //   CauseName: 'Violation of reason',
  //   CauseDetails: 'Detailed violation of reason',
  //   searchTraveller: 'Search Passenger',
  //   SearchZones: 'Select city',
  //   UserName: 'Name',
  //   LastName: 'Zhang Fei, fill: ZHANG',
  //   firstName: 'Zhang Fei, fill: FEI',
  //   CardNo: 'ID number',
  //   RecipientAddress: 'Address',
  //   RecipientPostcode: 'Zip code',
  //   OriginalPassword: 'Old password',
  //   Password: 'Password',
  //   NewPassword: 'New password',
  //   AffirmNewPassword: 'Confirm password',
  //   CompanyName: 'Company name',
  //   SelectCity: 'Select city',
  //   Industry: 'Industry',
  //   Account: 'Email, or mobile number',
  //   VerificationCode: 'Verification code',
  //   DynamicCode: 'Dynamic code',
  //   RegisterPhone: 'Phone number',
  //   Invoice: 'Tnvoice Header',
  //   InvoiceType: 'Invoice Type',
  //   Identifier: 'Required,Taxpayer Identifier number',
  //   UserID: 'Account',
  //   RefusalCause: 'The reason for rejection',
  //   CaseInsensitive: 'Case Insensitive',
  //   MessageAuthenticationCode: 'Message Authentication Code',
  //   DeparturePlace: 'Depart Place',
  //   ArrivePlace: 'Arrive Place',
  //   AddVoyage:'Add Voyage',
  //   ContactEmail:'Contact Email',
  //   ShipCompany:'Ship Company',
  //   Remarks:'Remarks',
  //   BankName:'Bank Name' ,
  //   BankAccount:'Bank Account',
  //   RegisteredAddress:'Registered Address',
  //   RegisteredPhone:'Registered Phone' ,
  //   TrainDetailReason:'Train Detail Reason'
  // },
  // system: {
  //   contacts: 'Contacts',
  //   HowToCall: 'What do you call you?',
  //   PerfectInformation: 'Please perfect gender, date of birth',
  //   BindingPhone: 'Binding phone',
  //   BindingEmail: 'Binding Email',
  //   AccountAssociated: 'Account Link',
  //   UpdatePassword: 'Change password',
  //   Language: 'Language',
  //   Chinese: 'CN',
  //   English: 'EN',
  //   ExitLogin: 'Login out',
  //   WeChat: 'WeChat',
  //   ImmediatelyBinding: 'Binding',
  //   AccountAssociated: 'Account Link',
  //   Password: 'Password',
  //   OriginalPassword: 'Old pwd',
  //   NewPassword: 'New pwd',
  //   AffirmNewPassword: 'ConPwd',
  //   ChangePassword: 'Change password',
  //   EditPersonalInformation: 'Edit Profile',
  //   CompanyName: 'Company',
  //   Industry: 'Industry',
  //   Account: 'Account',
  //   VerificationCode: 'VerCode',
  //   DynamicCode: 'DynCode',
  //   Register: 'Register',
  //   UserRegister: 'Personal',
  //   CompanyRegister: 'Business',
  //   ServiceAgreement: 'Agree to the agreement',
  //   SendDynamicCode: 'Send code',
  //   Sent: 'Sent',
  //   LoginTxt: 'Login in',
  //   DynamicPasswordLogin: 'Dynamic password login',
  //   ForgetPassword: 'Forgot Pwd',
  //   Integral: 'Integral',
  //   AllOrders: 'All orders',
  //   Obligation: 'Pending payment',
  //   NotToTravel: 'NoTravel',
  //   ToApproval: 'Approvaling',
  //   TicketInformation: 'Ticket',
  //   OrderInformation: 'Order',
  //   OrderID: 'OrderID',
  //   TradeID: 'Transaction number',
  //   TradeAmount: 'Total amount of order',
  //   CollectingCompany: 'Receipt company',
  //   PaymentWays: 'Payment method',
  //   Payment: 'Payment',
  //   ThePassengerInformation: 'Traveler',
  //   PassWordLogin: 'PassWord Login',
  //   CodeLogin: 'Code Login',
  //   Notice: 'Notice',
  //   RecentOrders: 'RecentOrder',
  //   Reserved: 'Reserved',
  //   CustomerService: 'Service',
  //   Sell: 'Sell',
  //   ContactUs: 'Contact Us',
  //   Call: 'Call',
  //   ServiceDept: 'Service Dept',
  //   AllOrders: 'All Orders',
  //   MyOrder: 'My Order',
  //   ApprovalDispose: 'ApprovalDispose',
  //   RetrievePwd: 'To login or retrieve pwd',
  //   ElectronicBills: 'Easy to receive electronic bills',
  //   ApprovalAccredit: 'Approval Accredit',
  //   AboutUs: 'About Us',
  //   TestGetCode: 'Get Code',
  //   PhoneHint: 'Effectively bind the phone to reset the password.',
  //   EmailHint: 'Effectively bind the email to reset the password.',
  //   LoginPassword: 'Login Password',
  //   ResetPassword: 'Reset Password',
  //   EnterAccount: "enter one's account number",
  //   PhoneVerification: 'Phone Verification',
  //   EmailVerification: 'Email Verification',
  //   SetBinding: 'Set Binding',
  //   Input: 'Input',
  //   Effective: 'Effective',
  //   Verify: 'Verify',
  //   NextStep: 'Next Step',
  //   RemarkString: 'Remark String',
  //   RefundFee: 'Refund Fee',
  //   CabinFee: 'Cabin Fee',
  //   ReimburseInfo: 'Reimburse Info',
  //   BaggageAllowance: 'Baggage Allowance',
  //   BackChangeRemark: 'The above rules and fee standards are for reference only. The actual fee shall be subject to the airline.',
  //   PartRoute:'Part Route',
  //   PartHotel:'Part Hotel',
  //   IsSaveCustomers:'Is Save Customers?',
  //   EmployeeRights:'EmplyRight',
  //   DateGranted:'DateGrant',
  //   ExpiryDate:'ExpiryDate',
  //   AddApproval:'Add/modify approval',
  //   AddApprovals:'Add Approvals',
  //   DownloadInstall:'Download Install',
  //   TopRightCorner:'Please click on the upper right corner',
  //   BrowserOpen:"I'm gonna say open in browser",
  //   CannotDownloaded:'WeChat /QQ app cannot be downloaded',
  //   CompanyProfile :'Company Profile',
  //   CompanyProfileContent:"Shanghai force's official website (www.lichengtrip.net) is affiliated with Shanghai force cheng cheng ticketing co., LTD., headquartered in Shanghai, China headquarters office located in changning district of Shanghai new spinning international business center, east near jing an temple cao home cross in the center of business, such as call center, general manager, finance department, ticketing and settlement department, international department, domestic peers department, customer service department, training department, the ministry of commerce, operations center and other relevant departments.It is a large-scale civil aviation service enterprise with wide sales scope, large service scale and strong comprehensive strength in Shanghai.",
  //   FutureProspects:'Future prospects',
  //   FutureProspectsContent:'In the rapid development of Internet technology in the 21st century, Shanghai force the business distribution system, which is a joint research and development of scientific research units, with advanced technology, with independent intellectual property rights in order to convenient streamlined engineering services in the world people all aspects of life, let each ordinary people living in a network society, have the opportunity to become a tide of network economy.Make them in every minute of the network life experience, experience of the Chinese nation excellent traditional culture and the perfect fusion of modern democratic way of life, feel the real human care and the enrichment of material life and ascension, to promote the network society, harmonious, stable and healthy development of the dedicated efforts of all people enthusiasm and wisdom!The year 2016 is a time for greater development of licheng. Driven by innovation and progress, licheng will further accelerate the development speed and improve the quality of development. With international and domestic air ticket sales as the main body and vacation reservation, it will implement the comprehensive development strategy and strive to promote informatization and build an information platform.',

  //   ManagementTeam:'Close and progressive management team',
  //   ManagementTeamContent:"The perfect combination of resources cooperation, management skills and business experience of the management team of Shanghai licheng, as well as the close and appropriate cooperation between the teams ensure the rapid and steady development of the company.Our senior management team brings together many years of business operation and management experience in the international IT industry, tourism and finance industry.The middle management team brings together the IT industry, aviation agency industry and tourism industry of China to ensure the service scale and resource scale management policy.",

  //   TechnicalService:'Leading technology and service',
  //   TechnicalServiceContent:"Licheng always regards technological innovation as the source of vitality of the enterprise and spares no effort in improving its r&d capability.Licheng has established a set of modern service system, driven by innovation and progress, to further accelerate the speed of development, improve the quality of development, with international and domestic air ticket sales as the main body, hotel booking, holiday booking simultaneously, the implementation of comprehensive development strategy, focus on promoting informatization, the construction of information platform.",
  //   AboutUs:'About Us',
  //   AboutUsContent:'tel：400-088-8020',



  // },
  // share: {
  //   hot: 'hot',
  //   calendarDataTitle: 'Select date',
  //   calendarDataExplain: 'Query date is the departure date',
  //   cancelTxt: 'Cancel',
  //   confirmTxt: 'Confirm',
  //   pullUpLoadMoreTxt: 'Load more',
  //   pullUpLoadNoMoreTxt: 'No more',
  //   RefreshTheSuccess: 'Refresh success',
  //   Save: 'Save',
  //   Add: 'Add',
  //   QueryBtn: 'Search',
  //   SubmitBtn: 'Submit',
  //   AmendBtn: 'Amend',
  //   FinishBtn: 'Finish',
  //   fail: {
  //     selectTraveller: 'Please choose a passenger!',
  //     minPrice: "Are you sure you want to continue booking?",
  //     CostCenter: 'Please enter the cost center! ',
  //     TravelPurpose: 'Please enter your travel purpose! ',
  //     EnglishName: 'The passenger has no English name!',
  //     RefundJourney: 'Please choose the itinerary you need to refund! ',
  //     RefundReason: 'Please choose the reason you need to refund! ',
  //     RefundTraveller: 'Please select the passenger you need to refund!',
  //     ChangeJourney: 'Please select the itinerary you need to change! ',
  //     ChangeTraveller: 'Please select the passenger you need to change! ',
  //     ChooseAnotherFlight: 'Please choose a flight from another airline! ',
  //     TheCorrectName: 'Please enter the correct first name and last name! ',
  //     UsreNameRepetition: 'The passenger name cannot be repeated! ',
  //     RegisterPhone: 'Please register or bind the phone number!',
  //     VerificationCode: 'Please enter the verification code.',
  //     DynamicCode: 'Please enter a dynamic code.',
  //     PassengerSurname: 'Please enter Surname.',
  //     PassengerName: 'Please enter Name.',
  //     RefusalCause: 'Please fill in the reason of refusal!',
  //     PhoneBinding: 'The bound phone number cannot be empty.',
  //     Phone: 'Please enter the correct mobile phone number.',
  //     Email: 'Please enter the correct mobile Email.',
  //     EmailBinding: 'The bound email cannot be empty.',
  //     VerificationTime: 'Verification code can only be obtained every 60s.',
  //     Account: 'Please enter your account number.',
  //     AccountEmpty: 'The account cannot be empty.',
  //     PasswordEmpty: 'The password cannot be empty.',
  //     PassengersNumbers: ' The number of passengers is limited, please contact customer service.',
  //     ManyPeople:'Too many people, please contact customer service for group purchase.',
  //     ChangeReason:'The reason for change cannot be blank',
  //     SeatNumbers: 'The number of passengers exceeds the number of seats selected',
  //     SelectSeat:'Please select a seat for the selected passenger'
  //   },
  //   succ: {
  //     SaveSucc: 'Saved successfully!',
  //     CancelSucc: 'Cancel success!',
  //     ApprovalRefused: 'Approval rejection!',
  //     ApproveSucc: 'Approved success!',
  //     RefundSucc: 'Return ticket application submitted successfully!',
  //     ChangeSucc: 'Change registration application submitted successfully!',
  //     RegisteredSucc: 'Registered successfully! ',
  //     LoginSucc: 'Login success! ',
  //     ChangePasswordSucc: 'Password changed successfully',
  //     VerificationSucc: 'Verification code sent successfully',
  //     AddSucc:'Add Succ',
  //   ModifySucc:'Modify Succ',
  //   DeleteSucc:'Delete Succ'
  //   },
  //   confirm: {
  //     YesOrNoDelect: 'Whether to confirm the deletion',
  //     CreateOrder:'The order has been created successfully. You are welcome to follow the order progress in the order details at any time',
  //     ThankRemarks:"Thanks for your trust and support to licheng business travel. In order to better enhance users' travel experience, licheng business travel officially launched the licheng business travel 2.0 system at 9:00 a.m. on October 30, 2018."
  //   },
  //   loading: {
  //     load: 'loading. . .',
  //     creatOrder: 'Order Createing. . .',
  //     PriceCalculation: 'Price Calculation'
  //   },

  // },
  // Categorys: {
  //   Young: 'Young',
  //   Enfant: 'Children',
  //   Infant: 'baby',
  //   economyClass: 'Economy',
  //   buissenesClass: 'Business',
  //   firstClass: 'First',
  //   OnBusiness: 'Business',
  //   OnPersonal: 'Personal',
  //   FlightService: 'Flight',
  //   HotelService: 'Hotel',
  //   TourService: 'Tour',
  //   TrainService: 'Train',
  //   SingleVoyage: 'Single',
  //   RoundVoyage: 'Round',
  //   WaitBooking: 'WaitBooking',
  //   WaitConfirm: 'WaitConfirm',
  //   WaitPayment: 'WaitPayment',
  //   WaitDispose: 'WaitDispose',
  //   Finished: 'Finished',
  //   Canceled: 'Canceled',
  //   Rejected: 'Rejected',
  //   Cannot: 'Cannot',
  //   WaitApprove: 'WaitApprove',
  //   Discrete: 'Discrete',
  //   WaitSubmit: 'WaitSubmit',
  //   WaitRefund: 'WaitRefund',
  //   Male: 'Male',
  //   Female: 'Female',
  //   IDCard: "IDCard",
  //   PassportCard: "Passport",
  //   StudentCard: "StudentCard",
  //   OfficerCard: "OfficerCard",
  //   HKMpermit: "HKMpermit",
  //   TaiWpermit: "TaiWpermit",
  //   OtherCard: "OtherCard",
  //   Company: 'Company',
  //   User: 'User',
  //   HotelFare: 'HotelFare',

  //   MobileAuth: 'Mobile Auth',
  //   EmailAuth: 'Email Auth',
  //   AccountAuth: 'Account Auth',
  //   WeixinAuth: 'Weixin Auth',
  //   DynamicAuth: 'Dynamic Auth',
  //   TicketFare:'TicketFare',
  //   MessageNotify:'MessNotify',
  //   MailNotify:'MailNotify',
  //   WechatNotify:'WechatNotify',
  //   AppNotify:'AppNotify',
  // },
  // RegExp: {
  //   AccountReg: {
  //     isEmpty: 'Account cannot be empty',
  //     isFormat: 'Account format is incorrect'
  //   },
  //   PwdReg: {
  //     isEmpty: 'Password cannot be empty',
  //     isFormat: 'Password format is incorrect'
  //   },
  //   ConfigPwd: {
  //     isEmpty: 'Password cannot be empty',
  //     isFormat: 'Inconsistent password'
  //   },
  //   VerificationCodeReg: {
  //     isEmpty: 'Verification code cannot be empty',
  //   },
  //   DynamicCodeReg: {
  //     isEmpty: 'Dynamic code cannot be empty',
  //   },
  //   ProtocolReg: {
  //     isFlag: ' Must comply with the agreement'
  //   }
  // }
  mall: {
    allprice: "full price",
    discount: "Dis",
    GivenName: 'Given Name',
    Surname: 'Surname',
    selectedseat: 'Select',
    noselectseat: 'Unselect',
    takeOff: 'Take Off',
    FillInfo: 'Fill Info',
    ExpiryDate: 'ExpiryDate',
    StartTime: "Starting time",
    EndTime: "End Time ",
    ToProcessDate: "Departure date",
    backTracking: "Return date",
    sharing: "Share",
    AirplaneModelTxt: "Airplane model",
    ticketfeeFloat: "This price does not include airrax, fuel and tax",
    peopleTypeExplain: "Booking instruction for children and infants",
    bookingTicketExplain: "If you are booking a child/infant ticket for public needs, please contact our customer service.",
    onlySeeDirect: "Only direct flights",
    hiddenSharedFlight: "Hide shared flights",
    ActualCarrier: "Actual carrier",
    stayTxt: "Stay",
    turnTxt: "Transit",
    priceRemarks: 'The following fees are per capita for "1 adult or 1 child or 1 infant"',
    AgreementPrice: "Agreement",
    tax: "Tax",
    trainHolderKeyWords: "Domestic train ticket",
    bookingRemarks: "Can only book up to 5 passengers at a time",
    beginTxt: "departure station ",
    passTxt: "passing by",
    endTxt: "destination ",
    StandingOrder: "Num",
    stationName: "Name",
    arrivalTimeTxt: "Arrival",
    departTimeTxt: "Depart",
    departDate: "Depart date",
    arrivalDate: "Arrival date",
    hotelHolderKeyWords: "Please enter a keyword/hotel name, etc.",
    HotelRemarks: "Please do not exceed 5 rooms with living time not more than 20 nights. For special reservations, please contact our customer service.",
    TrainRemarks: "Tips: The ticket purchase time is 7:30 - 22:30. Ticket purchase, change and refund must be no later than 30 minutes before the start of the trip. Please pay within 10 minutes for trips within the day. Please pay within 25 minutes for trips beyond 24 hours.",
    NoTrainSearch: "No train inquiry service is available during the current time",
    mapTxt: "map / navigation ",
    detailsOrFacilities: "Details / Facilities",
    noSooner: "None Breakfast",
    breakfast: "Breakfast",
    breakfastTxt: "Including breakfast",
    noCancellation: "Cannot cancel",
    timeToCancel: "Cancel within a time limit",
    RoomsTxt: "Room Number",
    hotelUnit: "night",
    checkInTxt: "Check in",
    checkOutTxt: "check out",
    checkInDate: "Check-in date",
    checkOutDate: "check-out date",
    Frequenter: "Frequent guest",
    Temporary: "temporary guest",
    TemporaryInformation: "temporary guest info",
    addFrequenter: "Add frequent guest",
    addTemporary: "Add temporay guest",
    TravelStandard: "Business trip standard",
    hightToLow: "From high to low",
    lowToHight: "From low to high",
    morningToNight: "Morning Till Night",
    nightToMorning: "From late to early",
    starLevelTxt: "Star",
    filtrateTxt: "Filter",
    timeTxt: "Time",
    fromTo: "From",
    portion: "Share",
    contactNumber: "Contact",
    conformToRules: "Conform",
    breakToRules: "Violating rules",
    unlimited: "Unlimited",
    beforeDay: "the day before ",
    afterDay: "the day after ",
    adequateTxt: "Sufficient",
    Remaining: "Only left",
    taxesTxt: "Tax",
    BackTorule: "Refund/Chang ",
    booking: "Book",
    onlinePay: "Pay",
    departTxt: "Set off ",
    arrivalTxt: "Arrive",
    sheet: "pcs",
    NoTicket: "None",
    orderFilltitle: "Fill order",
    tripInfosTitle: "Traveler Info",
    BookingInformation: "Booking Info",
    tripInfosRemarks: "In order to travel smoothly, please ensure that the items filled in are consistent with the documents held.",
    addTraveller: "Add passenger",
    UserName: "Name",
    contactInfosTitle: "Contact Info",
    RemarkInfosTitle: "Remarks",
    contacts: "Contact person",
    Phone: "Mobile",
    Email: "Email",
    InstructTitle: "Deduction instructions",
    InstructContent: "Pre-authorization or deduction of the room rate will be based on your payment method. If the order is not confirmed, the pre-authorization will be released or a full refund will be made to your payment account. This order cannot be cancelled after confirmation. If you do not check in, your first day room rate will be charged. If you check out early, the fee for the day you leave will be deducted.",
    SpecialTipsTitle: "Special Note ",
    SpecialTipsContent: "The hotel's check-in time is 14:00 and the standard check-out time is 12:00. If you check in early or postpone your check-out, you will be charged a fee as appropriate.",
    travelInformationTitle: "Travel info",
    CostCenter: "CostCenter",
    TravelPurpose: "Purpose",
    ProjectCode: "Code",
    contraryReason: "Reason",
    ViolateTravelRules: "Violate travel rules",
    SpecialRequirement: "Special needs",
    SpecialRequirementTips: "Special needs",
    specialRequirementContent: "We will try our best to coordinate your special needs. If we are unable to do that, there will be no further notice.",
    otherRequirement: "other needs",
    consentAgreement: "Click Submit to indicate that you have read and agreed",
    importantTerms: "Booking instructions and important terms",
    BookingHint: "To support the green environmental protection, we adopt default electronic contract, if you need to sign a paper contract, please call customer service.",
    CostDetails: "Charge Details ",
    payTotalPrice: "Total",
    totalPrice: "Total",
    roomUnit: "Room",
    nightUnit: 'night',
    peopleUnit: "People",
    details: "Detail",
    CustomerService: "Contact Customer Service ",
    SubmissionOrPayment: "Submit/pay",
    frequentlnformationTitle: "Passenger",
    TravellerTitle: "Passenger Name ",
    EnglishName: "English name ",
    LastName: "English last name",
    firstName: "English fisrst name ",
    NameOrIdCardTips: "In order to ensure smooth travel, please ensure that the travel name is consistent with the certificate.",
    CertificateInformatTitle: "Certificate Info ",
    ExpireDate: "Validity of cetficiate",
    otherInfosTitle: "Other Info ",
    Sex: "Sex",
    Birthday: "Birthday",
    Nationality: "Nationality",
    optionalCard: "Passenger card (optional)",
    reminderInfos: "In order to travel smoothly, please ensure that the travel end date is at least 6 months earlier than the validity period of the certficiate and confirm to fill in true and valid ID number, which will not be modified after the order is submitted.",
    addOrEditTraveller: "Add/Edit travelers",
    AllOrder: "All orders",
    orderStatus: "Status",
    departTime: "Depart time",
    orderDetail: "Order detail ",
    CancelOrder: "Cancel order ",

    CancelRefund: 'Cancel refund',
    CancelChange: 'Cancel change',
    ApprovalRefused: "Rejected ",
    ApproveSucc: "Approved ",
    PayNow: "Pay immediately ",
    Refund: "Refund",
    RefundHotel: "RefundHotel",
    RefundGroup: 'RefundGroup',
    Change: "Change",
    SubmitOrder: "Submit orders",
    PriceDetail: "Price detail",
    CheckOrderProgress: "View order progress",
    flightInformation: "flight information ",
    orderNumber: "Order number ",
    BookingTime: "Book Time",
    First: "No.",
    Journey: "Schedule",
    few: "Room",
    Level: "Level",
    BackToChangeTips: "The final amount is subject to the review. If you have any questions, please call customer service.",
    pleaseChoose: "please choose ",
    ThePassengers: "Traveler",
    Transfer: "Transit",
    Flight: "Flight",
    RefundRoomsDate: "Check-out and check-in time",
    TheReason: "reason for ",
    TheTrain: "Number of train",
    hour: "Hour",
    minute: "Minute",
    Gym: 'Gym',
    district: 'District',
    business: 'Business',
    ThePassengerInformation: "Passenger information",
    NewTrainInformation: "New train information",
    OriginalTrainInformation: "Original train information",
    NewFlightInformation: "New flight information",
    OriginalFlightInformation: "Original flight information",
    NextStep: "Next step",
    ChangeDate: "Change date",
    SelectChangeFlight: "Please select the changed flight",
    SelectRefundFlight: "Please select the refunded flight",
    SelectChangeTrain: "Please select the changed passenger",
    SelectRefundTrain: "Please select the passenger who refunds",
    SelectRefundHotel: "Please select the hotel for refund",
    SelectChangeDate: "Please select the date of change",
    Department: "Department",
    ApprovalStatus: "Status",
    ConfidentialInformation: "Voucher",
    TradeInformation: "Trading Info",
    Insurance: "Insurance Info",
    Home: "Home",
    Stroke: "Trip",
    Me: "My",
    TravelApproval: "Travel approval",
    TravelRulesName: "Travel rule name",
    MinimumPriceBase: "Lowest price benchmark",
    RealFlightControl: "Real-time flight control",
    AdvanceBookingTime: "Booking time in advance",
    ClassLimit: "Class level limit",
    SeatClassLimit: "Seat level limit",
    AgreementAirlinePriority: "Agreement ticket priority",
    AgreementHotelPriority: "Agreement hotel priority",
    MaximumAmountConsumption: "Maximum amount of consumption",
    ApprovalName: "Approval name",
    Other: "Other",
    FirstClassCity: "Primary city",
    SecondaryCity: "Secondary city",
    ThreeLevelCity: "Tertiary city",
    SeatSelectionService: "Seat selecting service",
    Bezel: "window",
    Aisle: "Aisle",
    NewContacts: "Add contact person",
    AdditionalInvoiceInformation: "Add/edit invoice Info",
    InvoiceInformation: "Invoice Information ",
    InvoiceTitle: "Rise",
    TariffItem: "Tax number",
    SetDefaultContacts: "Set default contact person",
    ConsigneeAddress: "Recipient Address ",
    NewCommonAddresses: "Add a common address",
    default: "default",
    City: "City",
    Address: "Address",
    Postcode: "Zip code",
    AddCommonAddresses: "Add/edit common addresses",
    DepartureTime: "departure time ",
    Airport: "Airport",
    ShippingSpace: "Cabin",
    AirlineCompany: "Airline",
    '150OrLess': "￥150 or more",
    '150And300': "￥150-300",
    '300And450': "￥300-450",
    '450And600': "￥450-600",
    '600OrMore': "￥600 or more",
    TwoStarsOrLess: "Two stars and below",
    ThreeStar: "Three stars/comfortable",
    FourStar: "Four stars/high-end",
    FivesStar: "Five stars/luxury",
    Apartment: "apartment",
    Inn: "inn",
    FamilyInn: "family hotel",
    YouthHostel: "youth hostel",
    CoupleHotel: "love hotel",
    GardenCourtyard: "garden courtyard",
    SeaView: "seaview",
    Farmhouse: "agritainment",
    HotSpringHotel: "hot spring hotel",
    GolfHotel: "golf hotel",
    Siheyuan: "quadrangle courtyard?",
    Villa: "villa",
    PartyCooking: "cooking party",
    BusinessTtravelHome: "business trip home",
    LeisureMood: "recreational feeling",
    SeeDoctor: "hospital",
    VacationLeisure: "holiday leisure",
    TrainAndLearn: "training and learning",
    GetTogether: "party",
    HoneymoonTrip: "honeymoon trip",
    boutiqueHotel: "boutique hotel",
    FreeWifi: "free wifi",
    FreeParking: "free parking lot",
    IndoorPool: "indoor swimming pool",
    OutdoorPool: "outdoor swimming pool",
    service: "gym",
    BusinessCenter: "business center",
    MeetingRoom: "meeting room",
    HotelRestaurant: "hotel restaurant",
    MorningCall: "wakeup call",
    LuggageStorage: "luggage deposit",
    TwinBed: "double bed",
    BigBed: "big bed",
    FreePickUpService: "free pickup service",
    Price: "Price",
    StarLevel: "Star",
    Specialtie: "Features",
    Service: "Service",
    DetailsOrFacilities: "Details/Facilities",
    HotelDetail: "Hotel details",
    ModelSelection: "Model selection",
    HighSpeedRail: "High-speed rail (G/C)",
    MotorCar: "EMU (D)",
    Ordinary: "Normal (Z/T/K)",
    DepartureOrArrival: "Departure/arrival station",
    Date: "Date",
    Status: "State",
    OldSystem: "Please use view on PC version",
    Welcome: "Welcome ",
    PleaseLogIn: "please log in ",
    FlightTips: "Cheap flight, comfortable trip",
    HotelTips: "Exclusive business trip",
    TrainTips: "Fast ticketing with one click",
    TourTips: "Featured Special Travel",
    Invoice: "Rise",
    InvoiceType: "Type",
    Identifier: "identification number ",
    TicketInquiry: "Ticket inquiry",
    TrainInquiry: "Train inquiry",
    HotelInquiry: "Hotel inquiry",
    ConsumerHotline: "consumer hotline ",
    WeChatService: "WeChat customer service",
    TravelPolicy: "Travel policy",
    EditData: "Edit Info",
    RecommendFlight: "Recommend",
    OriginalFlight: "Original flight",
    More: "More ",
    Hidden: "Hide",
    JetFuel: "Airrax、fuel",
    Booking: "Book",
    CurrentPosition: "current position ",
    Room: "room",
    SquareMeters: "square meter",
    CanLive: "tenantable",
    Floor: "floor",
    Layer: "layer",
    ServiceFee: "Service fee",
    InsurancePremium: "Insurance fee",
    Yuan: "Yuan",
    ContactHotel: "Contact hotel",
    After: "after",
    Before: "Before",
    For: "For",
    DueTo: "Due to",
    ViolationPolicy: "Violation policy",
    CompliancePolicy: "Compliance policy",
    BusinessInformation: "Business Info",
    Within: "Within",
    RefuseReason: "Reason",
    Against: "Violate",
    Policy: "Policy",
    DetailedReason: "Reason details",
    Wait: "Waiting",
    Approval: "Approval",
    Breach: "Violation",
    // Actually subject to the review of the airline
    AirlineAuditStandards: "In accordance with the latest regulations of the airline, customer service telephone number can be consulted",
    ConfirmOrder: "Confirm Order ",
    FlightInformation: "Flight Info",
    Voyage: "Flight",
    DeparturePlace: "Departure place ",
    ArrivePlace: "Arrive place",
    AddVoyage: "Add a voyage",
    PassengersNumbers: "Number of passengers",
    ShipType: "Class type",
    PassengersType: "Passenger Type ",
    ShipCompany: "Preferred airline",
    Remarks: "Remarks",
    PackUp: "PackUp",
    Show: "Expand",
    DocumentType: "CardID",
    CardNo: "CardNo",
    InvoiceRole: "Role",
    BankName: "Bank name ",
    BankAccount: "Bank Account",
    RegisteredAddress: "Registered address",
    RegisteredPhone: "Registered phone",
    ChangeReason: "Reason for change",
    VoucherNumber: "Voucher ID",
    CancelReason: "Reason for Cancellation ",
    ChildInfantBooking: "Booking instruction for children and infants",
    BookingInformation: 'Booking Info',
    boyin: "Boeing",
    kongke: "Airbus",
    AppropriationBudget: 'Appropriation Budget',
    Attendance: '参会人数',
    HostPlace: 'Host Place',
    Destination: 'Destination',
    ParticipantsNumber: 'Participants Number',
    ActivityBudget: 'Activity Budget',
    AmountPaid: 'Amount to be paid',
    ConfirmPayment: 'Confirm Payment',
    Pay: 'Pay',
    PriceTxt: 'Price'







  },
  placeholders: {
    contacts: "Please fill in the contact person's name",
    Email: "Required to fill to receive confirmation",
    CostCenter: "Please select a cost center",
    TravelPurpose: "Please choose the purpose of travel",
    ProjectCode: "Please fill in the project code",
    CauseName: "Please choose the reason for the violation",
    CauseDetails: "Please fill in the detailed reason for violation",
    searchTraveller: "Please enter your name ",
    SearchZones: "Chinese or pinyin of city or station",
    UserName: "Consistent with the number on the caerrtificate",
    LastName: "For example: Zhang Fei, fill: ZHANG",
    firstName: "For example: Zhang Fei, fill: FEI",
    CardNo: "ID number",
    Phone: "Please enter the phone number ",
    RecipientAddress: "Please enter the recipient address",
    RecipientPostcode: "Please enter the recipient zip code",
    OriginalPassword: "Please enter the original password",
    Password: "Please enter your password",
    NewPassword: "Please enter a new password ",
    AffirmNewPassword: "Please confirm your password ",
    CompanyName: "Please enter the company name",
    SelectCity: "Please select city ",
    Industry: "Please enter the industry",
    Account: "Please enter your mobile number or email address",
    VerificationCode: "please enter verification code ",
    DynamicCode: "Please enter a dynamic code",
    RegisterPhone: "Please register or bind your mobile number!",
    Invoice: "Invoice ",
    InvoiceType: "invoice type ",
    Identifier: "Required to fill taxpayer identification number",
    UserID: "Please enter an account",
    RefusalCause: "Please enter the reason for rejection",
    CaseInsensitive: "not case sensitive ",
    MessageAuthenticationCode: "SMS verification code ",
    DeparturePlace: "Departure place ",
    ArrivePlace: "Arrive place",
    ContactEmail: "please enter your email ",
    Remarks: "Please enter a note",
    ShipCompany: "Preferred airline",
    BankName: "Bank name ",
    BankAccount: "Bank Account ",
    RegisteredAddress: "Registered address ",
    RegisteredPhone: "Registered phone",
    TrainDetailReason: "Train detailed reason",
    PeopleNumber: 'Please enter number',
    AppropriationBudget: 'Please enter the budget',
    ContactNumber: 'Please enter your contact number',
    ContactRemarks: 'Let us know your most convenient contact time and way, so that we can reply to you at the most appropriate time.'
  },
  system: {
    EmailNotification: 'Email Notify',
    servicePhone: '400-088-8020',
    contacts: "Contact",
    servicePhone: '400-088-8020',
    Company: 'Licheng',
    Name: 'Licheng',
    HowToCall: "How to call you?",
    PerfectInformation: "Please complete your mobile number",
    BindingPhone: "bound phone",
    BindingEmail: "bound mailbox",
    AccountAssociated: "Account association",
    UpdatePassword: "Modify the login password",
    Language: "Language",
    Chinese: "CN",
    English: "EN",
    ExitLogin: "Logout",
    WeChat: "WeChat",
    ImmediatelyBinding: "Bind immediately",
    Password: "Password",
    OriginalPassword: "old password ",
    NewPassword: "new password ",
    AffirmNewPassword: "confirm password ",
    ChangePassword: "change Password ",
    EditPersonalInformation: "Edit Profile",
    CompanyName: "Company Name ",
    Industry: "Industry",
    Account: "Account",
    VerificationCode: "Verification code",
    DynamicCode: "Dynamic code",
    RegisterNow: "Register",
    Register: "Register",
    UserRegister: "Personal registration",
    CompanyRegister: "Company registration",
    ServiceAgreement: "Agree to Service Agreement of Licheng Travel Network ",
    SendDynamicCode: "Send dynamic code",
    Sent: "Has been sent ",
    LoginTxt: "Login ",
    DynamicPasswordLogin: "login with dynamic password ",
    ForgetPassword: "Forget password",
    Integral: "integral",
    AllOrders: "All orders",
    Obligation: "Paid ",
    NotToTravel: "Not Travelled",
    ToApproval: "Approved",
    TicketInformation: "Ticket Info",
    OrderInformation: "Order Info ",
    OrderID: "ID",
    TradeID: "Transaction number",
    TradeAmount: "The total amount of order",
    CollectingCompany: "Receivable Company ",
    PaymentWays: "Payment method ",
    Payment: "Pay",
    ThePassengerInformation: "Passenger Info",
    PassWordLogin: "Login by account",
    CodeLogin: "Login by dynamic code",
    Notice: "Notice ",
    RecentOrders: "Recent trip",
    Reserved: "Ordered",
    CustomerService: "Customer service",
    Sell: "Sales ",
    ContactUs: "Contact us ",
    Call: "Call",
    ServiceDept: "Customer Service Department",
    MyOrder: "My Order ",
    ApprovalDispose: "Approval",
    RetrievePwd: "Easy to log in or retrieve password",
    ElectronicBills: "Easy to receive electronic bills",
    ApprovalAccredit: "Approval and authorization",
    AboutUs: "About us",
    TestGetCode: "Verification",
    PhoneHint: "You can reset your password with a valid bound phone.",
    EmailHint: "You can reset your password with a valid bound mailbox.",
    LoginPassword: "login password ",
    ResetPassword: "reset password ",
    EnterAccount: "enter account ",
    PhoneVerification: "Phone verification ",
    EmailVerification: "E-mail verification ",
    SetBinding: "Set binding",
    Input: "Enter",
    Effective: "Valid",
    Verify: "Verify",
    NextStep: "Next step",
    RemarkString: "Time limit for changing",
    RefundFee: "Fee for refund ",
    Cabinfee: "Same-class rescheduling fee",
    ReimburseInfo: "Reimbursement information",
    BaggageAllowance: "Baggage allowance",
    BackChangeRemark: "The above rules for adult refund and change and fees are for reference only, subject to airline",
    PartRoute: "Partial route",
    PartHotel: "Parial hotels",
    IsSaveCustomers: "Whether to save frequent passenger",
    EmployeeRights: "Employee authority",
    DateGranted: "Date of grant",
    ExpiryDate: "Expiration date",
    AddApproval: "Add/modify approval",
    AddApprovals: "Add approval",
    DownloadInstall: "Download and install ",
    TopRightCorner: "Please click on the top right corner",
    BrowserOpen: "Select to open in browser",
    CannotDownloaded: "Unable to download app in WeChat/QQ",
    CompanyProfile: "Company Overview ",
    CompanyProfileContent: "Shanghai Licheng official website (www.lichengtrip.net) is affiliated to Shanghai Licheng Ticketing Co., Ltd. The company is headquartered in Shanghai, China. The office is located in Xindongfang International Business Center in Changning District, Shanghai, close to Jing'an Temple Caojiadu and other business centers. It has a call center, general management office, finance department, ticket settlement department, international department, domestic counterpart department, customer service department, training department, commercial department, operation center and other corresponding departments. It is a large-scale civil aviation service enterprise with wide sales scope, large service scale and strong comprehensive strength in Shanghai.",
    FutureProspects: "Future prospects ",
    FutureProspectsContent: "In the 21st century with rapid development of Internet technology, the business travel distribution system developed by Shanghai Licheng and research units uses advanced technology with independent intellectual property rights to facilitate the streamlined engineering and serve the ordinary people in the world. It makes every ordinary people living in the network society have the opportunity to become a palyer in the tide of the Internet economy, so that in the network life of every minute and second, they experience the perfect integration of the excellent traditional culture of the Chinese nation and the modern democratic lifestyle, feel the tangible humanistic care and the continuous enrichment and enhancement of material life, to contribute all the enthusiasm and wisdom of Licheng people to the promotion of the healthy, harmonious and stable development of the network society! In 2016, Licheng ushers in higher development. We will take innovation and enterprising as motive, further accelerate the development speed and improve the development quality, take international and domestic air ticket sales as the mainstay and also develop vacation bookings, and implement a comprehensive development strategy to promote informationization and build an information platform.",
    ManagementTeam: "Close enterprising management team",
    ManagementTeamContent: "The perfect combination of the management teams of Shanghai Licheng in resource cooperation, management skills, business experience and close cooperation between among teams ensure the rapid and steady development of the company. Our senior management team brings together many years of experience in operations and management of international IT, tourism and finance industries; the middle management team brings together China's IT industry, aviation agency industry and tourism industry, ensuring the management policy of service scale and resource scale.",
    TechnicalService: "Technology leadership and service",
    TechnicalServiceContent: "Licheng has always regarded technological innovation as a source of vitality for the company and spared no effort in improving its research and development capabilities. Licheng has established a set of modern service system with innovation and enterprising as the driving force, to further accelerate the development speed and improve the development quality. With international and domestic ticket sales as the mainstay, we also develop hotel reservations and vacation reservations, and implement a comprehensive development strategy to promote informationization and build an information platform.",
    AboutUsContent: 'tel：400-088-8020',
  },
  share: {
    hot: "#",
    calendarDataTitle: "Select date",
    calendarDataExplain: "The inquired date is the departure date",
    cancelTxt: "Cancel",
    confirmTxt: "Confirm",
    pullUpLoadMoreTxt: "load more ",
    pullUpLoadNoMoreTxt: "no more ",
    RefreshTheSuccess: "Refresh successfully",
    Save: "Save",
    Add: "Add",
    QueryBtn: "Search",
    SubmitBtn: "Submit",
    AmendBtn: "Modify",
    FinishBtn: "Complete",
    fail: {
      CancelOrder: 'Please choose to cancel the order',
      RefundOrder: 'Please choose to cancel the refund order',
      selectTraveller: "Please choose a passenger!",
      minPrice: "You are not selecting the recommended flight or class, confirm to continue booking?",
      CostCenter: "Please enter the cost center!",
      TravelPurpose: "Please enter your travel purpose!",
      EnglishName: "The passenger does not have an English name!",
      RefundJourney: "Please select the itinerary you need to refund!",
      RefundReason: "Please select the reason for refund!",
      RefundTraveller: "Please select the passenger you need to refund!",
      ChangeJourney: "Please select the itinerary you need to change!",
      ChangeTraveller: "Please select the passenger you need to change!",
      ChooseAnotherFlight: "Please select a flight from another airline!",
      TheCorrectName: "Please enter the correct first name and last name!",
      UsreNameRepetition: "The passenger name cannot be repeated!",
      RegisterPhone: "Please register or bind your mobile number!",
      VerificationCode: "please enter verification code ",
      DynamicCode: "Please enter a dynamic code",
      PassengerSurname: "Please enter the passenger's last name",
      PassengerName: "Please enter the passenger's first name",
      RefusalCause: "Please fill in the reason for rejection!",
      PhoneBinding: "The bound phone number cannot be blank",
      EmailBinding: "The bound mailbox cannot be blank",
      Phone: "please enter a correct phone number ",
      Email: "please enter a correct emailbox",
      VerificationTime: "Get a verification code every 60s",
      Account: "Please enrer account",
      AccountEmpty: "Account cannot be blank",
      PasswordEmpty: "password can not be blank ",
      PassengersNumbers: "The number of passengers has been capped, please contact customer service",
      ManyPeople: "Too many people, please contact customer service for group purchase.",
      ChangeReason: "The reason for the change cannot be blank",
      SeatNumbers: "The number of passengers exceeds the number of seats selected",
      SelectSeat: "Please select a seat for the selected passenger",
    },
    succ: {
      SaveSucc: "Successfully saved!",
      CancelSucc: "Successfully cancelled!",
      ApprovalRefused: "Rejected!",
      ApproveSucc: "Approved!",
      RefundSucc: "Refund application submitted successfully",
      ChangeSucc: "The application for the change is submitted successfully!",
      RegisteredSucc: "Register successfully!",
      LoginSucc: "Log in successfully!",
      ChangePasswordSucc: "Password modified successfully!",
      VerificationSucc: "The verification code is sent successfully.",
      AddSucc: "Added successfully ",
      ModifySucc: "Modified successfully ",
      DeleteSucc: "Deleted successfully ",
      WeChat: 'WeChat unbound successfully'
    },
    confirm: {
      YesOrNoDelect: "Confirm to delete?",
      CreateOrder: "The order is created successfully, please keep an eye on the order progress in the order details at any time.",
      ThankRemarks: "Thank you for your long-term trust and support for Licheng Business Travel. In order to better enhance the user's travel experience, Licheng Business Travel officially launches Licheng Business Travel 2.0 system from 9:00 am on October 30, 2018. Users can automatically update through in App Store. For Android system, please contact our customer service and contact the emergency number 15901610043. Thank you!",
    },
    loading: {
      load: "Try to load. . .",
      creatOrder: "The order is being created. . .",
      PriceCalculation: "Price calculating...",
    }
  },
  Categorys: {
    Young: "Adult",
    Enfant: "Child",
    Infant: "Infant",
    economyClass: "Economic class",
    buissenesClass: "Business class",
    firstClass: "First class",
    OnBusiness: "Public",
    OnPersonal: "Private",
    FlightService: "Flight",
    HotelService: "Hotel",
    TourService: "Travel",
    TrainService: "Train",
    SingleVoyage: "One way ",
    RoundVoyage: "Round trip ",
    WaitBooking: "To be booked",
    WaitConfirm: "to be confirmed ",
    WaitPayment: "Paid ",
    WaitDispose: "To be processed ",
    Finished: "completed ",
    Canceled: "Cancelled ",
    Rejected: "Returned",
    Cannot: "Temporarily cannot",
    WaitApprove: "WaitApprove",
    Discrete: "Split",
    WaitSubmit: "To be submiited",
    WaitRefund: "To be refunded",
    Male: "Male",
    Female: "Female ",
    IDCard: "IDCard",
    PassportCard: "Passport",
    StudentCard: "Student card ",
    OfficerCard: "Military officer card",
    HKMpermit: "Exit-Entry Permit for Travelling to and from Hong Kong and Macao ",
    TaiWpermit: "Travel Permit for Mainlanders to Enter and Exit Taiwan",
    OtherCard: "Other",
    Company: "Company ",
    User: "User",
    HotelFare: "Room rate ",
    TicketFare: "Ticket face",
    MobileAuth: "Mobile",
    EmailAuth: "Email",
    AccountAuth: "account password ",
    WeixinAuth: "WeChat authorization",
    DynamicAuth: "dynamic password ",
    MessageNotify: "SMS notification",
    MailNotify: "E-mail notification ",
    WechatNotify: "WeChat notification",
    AppNotify: "App notification",
    Normal: 'Normal',
    OverseasStudent: 'Student',
    Worker: 'Worker',
    Immigrant: 'Immigrant',
    '1138Categorys': 'IDCard',
    '1139Categorys': 'Passport',
    '1140Categorys': 'Student',
    '1141Categorys': 'Officer',
    '1298Categorys': 'HKMpermit',
    '1299Categorys': 'TaiWpermit',
    '1142Categorys': 'Other',
    Finished: "Finished",
    Amended: 'Part Amended',
    Amending: 'Part Amending',
    Changeing: 'Part Changeing',
    Changeed: 'Part Changeed',
    AllAmending: 'Amending',
    AllChangeing: 'Changeing',
    AllBooking: 'Booking',
    AllAmended: 'Amended',
    AllChangeed: 'Changeed',
    AllBooked: 'Booked',
















    AmendingFlight: 'Part Amending',
    ChangeingFlight: 'Part Changeing',
    AmendingTrain: 'Part Amending',
    ChangeingTrain: 'Part Changeing',
    AmendingHotel: 'Part Amending',
    ChangeingHotel: 'Part Changeing',
    AmendingTour: 'Part Amending',
    ChangeingTour: 'Part Changeing',
    AmendedFlight: 'Part Amended',
    ChangeedFlight: 'Part Changeed',
    AmendedTrain: 'Part Amended',
    ChangeedTrain: 'Part Changeed',
    AmendedHotel: 'Part Amended',
    ChangeedHotel: 'Part Changeed',
    AmendedTour: 'Part Amended',
    ChangeedTour: 'Part Changeed',
    AllAmendingFlight: 'Amending',
    AllChangeingFlight: 'Changeing',
    AllBookingFlight: 'Booking',
    AllAmendingTrain: 'Amending',
    AllChangeingTrain: 'Changeing',
    AllBookingTrain: 'Booking',
    AllAmendingHotel: 'Amending',
    AllChangeingHotel: 'Changeing',
    AllBookingHotel: 'Booking',
    AllAmendingTour: 'Amending',
    AllChangeingTour: 'Changeing',
    AllBookingTour: 'Booking',
    AllAmendedFlight: 'Amended',
    AllChangeedFlight: 'Changeed',
    AllBookedFlight: 'Booked',
    AllAmendedTrain: 'Amended',
    AllChangeedTrain: 'Changeed',
    AllBookedTrain: 'Booked',
    AllAmendedHotel: 'Amended',
    AllChangeedHotel: 'Changeed',
    AllBookedHotel: 'Booked',
    AllAmendedTour: 'Amended',
    AllChangeedTour: 'Changeed',
    AllBookedTour: 'Booked',


  },
  RegExp: {
    AccountReg: {
      isEmpty: "Account cannot be blank",
      isFormat: "Account format is incorrect",
    },
    PwdReg: {
      isEmpty: "Password cannot be blank",
      isFormat: "Password format is incorrect",
    },
    ConfigPwd: {
      isEmpty: "Password cannot be blank",
      isFormat: "Inconsistent password",
    },
    VerificationCodeReg: {
      isEmpty: "Verification code cannot be blank",
    },
    DynamicCodeReg: {
      isEmpty: "Dynamic code cannot be blank",
    },
    ProtocolReg: {
      isFlag: "Must comply with the agreement",
    }
  },
}



// WEBPACK FOOTER //
// ./src/language/english.js